// Import and register all your controllers

import { application } from "./application"

// Import all controllers manually
import AutomaticCheckoutController from "./automatic_checkout_controller"
import CheckoutController from "./checkout_controller"
import ExpandableController from "./expandable_controller"
import ModalController from "./modal_controller"
import RatingController from "./rating_controller"
import SlideController from "./slide_controller"
import TipController from "./tip_controller"
import GalleryController from "./gallery_controller"

// Register controllers
application.register("automatic-checkout", AutomaticCheckoutController)
application.register("checkout", CheckoutController)
application.register("expandable", ExpandableController)
application.register("modal", ModalController)
application.register("rating", RatingController)
application.register("slide", SlideController)
application.register("tip", TipController)
application.register("gallery", GalleryController)
